import React from 'react'
import { Props } from 'models/sectionForYou'
import { sanitizeHtml } from 'utils/sanitizeHtml'
import { MyCardTwo } from 'modules/common/Cards/CardTwo.styles'

import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import { MyForYou } from './ForYou.styles'
import { Headline } from 'modules/common/Headline/Headline'

const responsive = {
    desktop1: {
        breakpoint: { max: 3000, min: 1480 },
        items: 3,
        // partialVisibilityGutter: 128
    },

    tablet: {
        breakpoint: { max: 1024, min: 600 },
        items: 2,
        partialVisibilityGutter: 10
    },

    mobile: {
        breakpoint: { max: 599, min: 0 },
        items: 1,
        partialVisibilityGutter: 20
    }
}

export const ForYou: React.FC<Props> = ({id, dataForYou}) => {
    const dataSolutions = dataForYou?.[0];

    if(!dataSolutions) return null;
    return(
        <MyForYou.block id={id}>
            <MyForYou.wrapper>
                <Headline
                    props={{
                        title: dataSolutions.title,
                        description: dataSolutions.description
                    }}
                />

                <Carousel partialVisible={true} responsive={responsive} arrows={false}>
                    { dataSolutions.solutions.map(item => (
                        <MyCardTwo.block className={item.model}>
                            <MyCardTwo.wrapper className={item.model}>
                                <MyCardTwo.title>{item.title}</MyCardTwo.title>         
                                
                                <MyCardTwo.wraoImage>
                                    <MyCardTwo.image src={item.image} alt={item.title} />
                                </MyCardTwo.wraoImage>         
                                                    
                                <MyCardTwo.text>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: sanitizeHtml(item.text)
                                        }}
                                    />
                                </MyCardTwo.text>

                                <MyCardTwo.CTA href={item.actions?.[0].url}>
                                    {item.actions?.[0].title}
                                </MyCardTwo.CTA>
                            </MyCardTwo.wrapper>
                        </MyCardTwo.block>
                    ))}
                </Carousel>

            </MyForYou.wrapper>
        </MyForYou.block>
    )
}